import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const Store24: FC<IconV2Props> = ({ icon, className }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`, className)}
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g fillRule="nonzero" fill="none">
      <path d="M21 7v13H4V7h17Zm-1 1H5v11h15V8Z" fill="#000" />
      <path d="M18.5 4v4h-12V4h12Zm-1 1h-10v2h10V5Z" fill="#000" />
      <path d="M13 10v10H7V10h6Zm-1 1H8v8h4v-8Z" fill="#070707" />
      <path d="M18 10v10h-6V10h6Zm-1 1h-4v8h4v-8Z" fill="#070707" />
      <path fill="#000" d="M11 14v3h-1v-3zM15 14v3h-1v-3z" />
    </g>
  </svg>
);

export default Store24;
